import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams, useNavigate } from 'react-router-dom';

import GroupReqRulesConfig from './GroupReqRulesConfig';
import RulesForUser from './RulesForUser';
import { RuleTabType } from './types';

enum TabViewType {
  GROUP = 'group',
  USER = 'user',
}

export default function UserReqRulesConfig() {
  const [searchParams] = useSearchParams();
  const user = searchParams.get('user');
  const [activeTab, setActiveTab] = useState<TabViewType>(() =>
    user ? TabViewType.USER : TabViewType.GROUP,
  );
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="space-y-4">
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8">
          <button
            onClick={() => {
              setActiveTab(TabViewType.GROUP);
              const params = new URLSearchParams(searchParams);
              params.delete('tab');
              navigate(`?${params.toString()}`);
            }}
            className={`${
              activeTab === TabViewType.GROUP
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
          >
            {t('manager.rulesConfig.rulesSummary')}
          </button>
          <button
            onClick={() => {
              setActiveTab(TabViewType.USER);
              const params = new URLSearchParams(searchParams);
              if (!params.get('tab')) {
                params.set('tab', RuleTabType.INCLUSION);
              }
              navigate(`?${params.toString()}`);
            }}
            className={`${
              activeTab === TabViewType.USER
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
          >
            {t('manager.rulesConfig.rulesPerUser')}
          </button>
        </nav>
      </div>

      {activeTab === TabViewType.GROUP ? (
        <GroupReqRulesConfig />
      ) : (
        <RulesForUser />
      )}
    </div>
  );
}
